import {
  infiniteQueryOptions,
  type InfiniteData,
  type QueryClient,
} from '@tanstack/react-query';
import { otcAPI } from '../api/otc';

export const OTC_HALL_PAGE_SIZE = 30;
export const OTC_HALL_QUERY_KEY = ['otc', 'hall'] as const;
export const OTC_HALL_STALE_MS = 45_000;

type HallPage = { total: number; page: number; limit: number; rows: Record<string, unknown>[] };

export function otcHallInfiniteQueryOptions() {
  return infiniteQueryOptions({
    queryKey: OTC_HALL_QUERY_KEY,
    queryFn: ({ pageParam }) =>
      otcAPI.getHall({
        page: pageParam,
        limit: OTC_HALL_PAGE_SIZE,
        side: 'sell',
        status: 'done',
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: HallPage, allPages: HallPage[]) => {
      const loaded = allPages.reduce((n, p) => n + (p.rows?.length ?? 0), 0);
      return loaded < (lastPage.total ?? 0) ? allPages.length + 1 : undefined;
    },
    staleTime: OTC_HALL_STALE_MS,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}

/** Warm hall feed while user is on wallet / other tabs. */
export function prefetchOtcHall(qc: QueryClient): void {
  void qc.prefetchInfiniteQuery(otcHallInfiniteQueryOptions());
}

export function getOtcHallCachedRows(
  qc: QueryClient,
): Record<string, unknown>[] | undefined {
  const data = qc.getQueryData<InfiniteData<HallPage>>(OTC_HALL_QUERY_KEY);
  return data?.pages.flatMap((p) => p.rows ?? []);
}
